module.exports = __webpack_public_path__ + "static/media/icone-cortado.1217ba9b.png";